import { ICountryExchangeDetail } from 'types/countries';
import { PRODUCT_TYPE_OPTIONS } from '../constants';
import ProductType from '../components/ProductType/ProductType';
import { IProductType } from '../DownloadUploadCatalog.types';

export const renderCheckboxOptions = (
  replaceCatalogue: boolean,
  handleReplaceCatalogue: (value: boolean) => void,
  checkboxDisabled: boolean
) => [
  {
    label: '¿Qué quieres hacer con el catálogo?',
    type: 'checkbox' as const,
    options: [
      {
        label: 'Solo actualizar información',
        checked: !replaceCatalogue,
        handleChange: () => handleReplaceCatalogue(false),
        disabled: checkboxDisabled
      },
      {
        label: 'Reemplazar catálogo',
        checked: replaceCatalogue,
        handleChange: () => handleReplaceCatalogue(true),
        disabled: checkboxDisabled
      }
    ]
  }
];

export const renderDropdownOptionsUpload = (
  countries: ICountryExchangeDetail[],
  selectedCountry: ICountryExchangeDetail | undefined,
  handleSelectedCountry: (country: ICountryExchangeDetail) => void
) => [
  {
    label: 'Pais*',
    options: countries.map(country => ({
      label: country.country || '',
      value: country?.id?.toString() || '',
      handleChange: () => handleSelectedCountry(country)
    })),
    type: 'dropdown' as const,
    defaultOption: {
      label: selectedCountry?.country || 'Selecciona el país',
      value: selectedCountry?.id?.toString() || '',
      isFilled: !!selectedCountry
    }
  }
];

export const renderDropdownOptionsDownload = (
  countries: ICountryExchangeDetail[],
  selectedCountry: ICountryExchangeDetail | undefined,
  handleSelectedCountry: (country: ICountryExchangeDetail) => void,
  selectedProductType: IProductType | undefined,
  handleSelectedProductType: (productType: IProductType) => void,
  isOnlyDevsAutomates?: boolean
) => [
  {
    label: 'Pais*',
    options: countries.map(country => ({
      label: country.country || '',
      value: country?.id?.toString() || '',
      handleChange: () => handleSelectedCountry(country)
    })),
    type: 'dropdown' as const,
    defaultOption: {
      label: selectedCountry?.country || 'Selecciona el país',
      value: selectedCountry?.id?.toString() || '',
      isFilled: !!selectedCountry
    }
  },
  {
    label: 'Tipo de productos*',
    options: PRODUCT_TYPE_OPTIONS.filter(option => isOnlyDevsAutomates || option?.id !== 3).map(option => {
      const description = option?.id === 1 && isOnlyDevsAutomates ? option?.description2 || '' : option?.description;

      return {
        label: option.title,
        element: (
          <ProductType
            key={option.id}
            title={option.title}
            description={description}
            onClick={() => handleSelectedProductType(option)}
          />
        )
      };
    }),
    type: 'dropdown' as const,
    defaultOption: {
      label: selectedProductType?.title || 'Selecciona el tipo',
      value: selectedProductType?.id.toString() || '',
      isFilled: !!selectedProductType
    }
  }
];
